/**
 * Resolves the root organizational unit of the given unit. The root unit
 * itself has no `root` relation, in which case the unit is its own root.
 *
 * Typed structurally instead of via `OrganizationalUnit` because
 * `@wilson/interfaces` depends on `@wilson/utils` and importing it here
 * would create a circular library dependency.
 */
export function getRootOrgUnit<T extends { root?: object | null }>(
  orgUnit: T,
): NonNullable<T['root']> | T {
  return orgUnit.root ?? orgUnit;
}
